import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentDisclosuresBrokerageData,
  type EnrollmentDisclosuresBrokerageSubmitOutput,
} from '../../../models'

export const getEnrollmentDisclosuresBrokerageDataMock: EnrollmentDisclosuresBrokerageData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: 'enrollment/investments/brokerage/disclosures',
  enrollmentData: {
    experimentId: 'BARBECUE',
    investmentProfile: {
      account: {
        includeCompanionAccount: true,
      },
    },
  },
}

export const submitEnrollmentDisclosuresBrokerageDataMock: EnrollmentDisclosuresBrokerageSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/brokerage/welcome',
}

export const mockGetEnrollmentDisclosuresBrokerageData = graphql.mutation(
  'getEnrollmentDisclosuresBrokerageData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentDisclosuresBrokerageDataMock } })
  },
)

export const mockSubmitEnrollmentDisclosuresBrokerageData = graphql.mutation(
  'submitEnrollmentDisclosuresBrokerageData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentDisclosuresBrokerageDataMock } })
  },
)

export const mockEnrollmentDisclosuresBrokerage = [
  mockGetEnrollmentDisclosuresBrokerageData,
  mockSubmitEnrollmentDisclosuresBrokerageData,
]
